import React from 'react'

import getLabels from '../../utils/getLabels'

import styles from './NoAllotmentCount.module.scss'
import globalStyles from '../../styles/global.module.scss'

export default () => (
  <div
    className={`${globalStyles['section-item']} ${styles['form-container']}`}
  >
    <h2 className={styles['title']}>{getLabels('new_booking_title')}</h2>
    <p>{getLabels('error_no_bookings_for_flight')}</p>
  </div>
)
